import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PersonalVisitActionBarComponent } from './component/personal-visit-action-bar.component';

import { DictionaryModule } from '@sdbn/common';
import { CommonLayoutModule, CommonUIModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';

import { MatTooltipModule as MatTooltipModule } from '@angular/material/tooltip';


@NgModule({
  declarations: [
    PersonalVisitActionBarComponent
  ],
  imports: [
    CommonModule,
    DictionaryModule,

    CommonLayoutModule,
    CommonTranslationModule,
    CommonUIModule,
    MatTooltipModule
  ]
})
export class PersonalVisitActionBarModule { }
